export default class MainContactForm {
  constructor() {
    if (this.vars()) {
      this.setupEvents();
    }
  }

  vars() {
    this.form = document.getElementById("mainContactForm");
    if (!this.form) return;

    this.action = this.form.getAttribute("action");
    this.elements = this.form.elements;
    [this.submit] = this.form
      .closest(".modal-dialog")
      .querySelectorAll(".submit");

    this.hp = document.getElementById("mcf_field_footer");

    this.rules = {
      email: {
        rule: "required",
        message: "E-mail jest wymagany"
      },
      msg: {
        rule: "required",
        message: "Wiadomość jest wymagana"
      }
    };

    this.emailRegex = new RegExp(
      "^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$"
    );
    this.errors = [];

    return true;
  }

  setupEvents() {
    this.submit.addEventListener("click", evt => this.handleSubmit(evt));
    this.form.addEventListener("submit", evt => this.handleSubmit(evt));
  }

  handleSubmit(evt) {
    evt.preventDefault();

    this.clearValidationErrors();

    if (this.hp.value.length > 0) return false;

    const data = this.buildData();

    if (!this.errors.length) {
      this.send(data);
    } else {
      this.throwValidationError();
    }
  }

  buildData() {
    let data = new FormData();

    for (let i = 0; i < this.elements.length; i++) {
      const el = this.elements[i];

      if (el.getAttribute("type") !== "submit") {
        const key = el.getAttribute("name");
        const val = el.value !== "placeholder" ? el.value : "";
        this.validate(key, val);
        data.append(key, val);
      }
    }

    return data;
  }

  send(data) {
    this.submit.setAttribute("disabled", true);
    axios
      .post(this.action, data)
      .then(response => {
        if (response && response.data.code === 200) {
          document._kweber.toast({
            type: "success",
            title: "Wiadomość wysłana!"
          });
          $("#mainContactModal").modal("hide");
        } else {
          throw new Error(response);
        }
        this.submit.removeAttribute("disabled");
      })
      .catch(error => {
        document._kweber.toast({
          type: "error",
          title: "Błąd wysyłki, spróbuj ponownie"
        });
      });
  }

  validate(key, val) {
    if (val === undefined) return;

    if (this.rules[key] !== undefined) {
      if (this.rules[key].rule === "required") {
        if (!val.length) {
          const error = {
            name: key,
            msg: this.rules[key].message
          };
          this.errors.push(error);
        }
      }
    }

    if (key === "mcf_email" && val.length) {
      if (!val.match(this.emailRegex)) {
        const error = {
          name: key,
          msg: "Niepoprawny adres e-mail"
        };
        this.errors.push(error);
      }
    }
  }

  throwValidationError() {
    this.errors.forEach(error => {
      const field = this.elements.namedItem(error.name);
      const node = field.closest("div");
      field.classList.add("form-invalid-right");
      node.appendChild(this.getErrorNode(error.name, error.msg));
    });
  }

  clearValidationErrors() {
    this.errors = [];
    const errorNodes = this.form.getElementsByClassName("form-error");
    const errorFields = this.form.getElementsByClassName("form-invalid-right");
    Array.from(errorNodes).forEach(node => {
      node.remove();
    });

    Array.from(errorFields).forEach(field => {
      field.classList.remove("form-invalid-right");
    });
  }

  getErrorNode(key, msg) {
    const label = document.createElement("label");
    label.setAttribute("for", key);
    label.classList.add("form-error");
    label.classList.add("form-invalid-right");
    label.innerText = msg;
    return label;
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/Forms/MainContactForm.js